import { render, staticRenderFns } from "./DireccionDialogComponent.vue?vue&type=template&id=cb10f640&scoped=true"
import script from "./DireccionDialogComponent.vue?vue&type=script&lang=ts"
export * from "./DireccionDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./DireccionDialogComponent.vue?vue&type=style&index=0&id=cb10f640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb10f640",
  null
  
)

export default component.exports